import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PeriodIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PeriodIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.125 3H4.875C4.59863 3 4.375 2.77637 4.375 2.5C4.375 2.22363 4.59863 2 4.875 2H19.125C19.4014 2 19.625 2.22363 19.625 2.5C19.625 2.77637 19.4014 3 19.125 3Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.125 22H4.875C4.59863 22 4.375 21.7764 4.375 21.5C4.375 21.2236 4.59863 21 4.875 21H19.125C19.4014 21 19.625 21.2236 19.625 21.5C19.625 21.7764 19.4014 22 19.125 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2661 21.5869C16.9898 21.5869 16.7661 21.3633 16.7661 21.0869V16.75C16.7661 13.4766 11.9341 12.292 11.8853 12.2803C11.6548 12.2266 6.23389 10.9043 6.23389 6.83691V2.5C6.23389 2.22363 6.45752 2 6.73389 2C7.01026 2 7.23389 2.22363 7.23389 2.5V6.83691C7.23389 10.1211 12.0659 11.2959 12.1147 11.3076C12.3452 11.3613 17.7661 12.6836 17.7661 16.75V21.0869C17.7661 21.3633 17.5425 21.5869 17.2661 21.5869Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.73389 21.5869C6.45752 21.5869 6.23389 21.3633 6.23389 21.0869V16.75C6.23389 12.6836 11.6548 11.3613 11.8853 11.3076C11.9341 11.2959 16.7661 10.1113 16.7661 6.83692V2.5C16.7661 2.22363 16.9898 2 17.2661 2C17.5425 2 17.7661 2.22363 17.7661 2.5V6.83691C17.7661 10.9043 12.3452 12.2266 12.1147 12.2803C12.0659 12.292 7.23389 13.4766 7.23389 16.75V21.0869C7.23389 21.3633 7.01026 21.5869 6.73389 21.5869Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PeriodIcon;
